import { apiClient } from '@features/shared/api/client'
import type {
  MicrosoftConnectionStatus,
  MicrosoftConnectionAction,
  MicrosoftCallbackRequest,
  MicrosoftCallbackResult,
  SenderPermission,
  MicrosoftSenderList,
} from './contracts'

const base = '/integrations/microsoft'

export async function getMicrosoftConnection(signal?: AbortSignal) {
  return (await apiClient.get<MicrosoftConnectionStatus>(base, { signal })).data
}

export async function connectMicrosoft() {
  return (
    await apiClient.post<MicrosoftConnectionAction>(`${base}/connect`, {}, { timeout: 90000 })
  ).data
}

export async function completeMicrosoftConnection(body: MicrosoftCallbackRequest) {
  return (
    await apiClient.post<MicrosoftCallbackResult>(`${base}/callback`, body, { timeout: 60000 })
  ).data
}

export async function checkMicrosoftConnection(signal?: AbortSignal) {
  return (
    await apiClient.post<MicrosoftConnectionStatus>(`${base}/check`, {}, { timeout: 90000, signal })
  ).data
}

export async function disconnectMicrosoft() {
  return (await apiClient.delete<MicrosoftConnectionStatus>(base, { timeout: 90000 })).data
}

export async function getMicrosoftSenders(signal?: AbortSignal) {
  return (await apiClient.get<MicrosoftSenderList>(`${base}/senders`, { timeout: 90000, signal }))
    .data
}

export async function checkMicrosoftSender(
  senderEmail: string,
  forceRefresh = false,
  signal?: AbortSignal
) {
  return (
    await apiClient.post<SenderPermission>(
      `${base}/sender-permissions`,
      {
        sender_email: senderEmail,
        force_refresh: forceRefresh,
      },
      { timeout: 90000, signal }
    )
  ).data
}
